import { useTranslation } from 'react-i18next';
import { useTransaction } from '../../../context/TransactionContext';
import { ITransaction } from '../../../interface/transaction';

export const useCopyTransactionBanner = () => {
  const { t } = useTranslation();
  const { transaction, updateTransaction } = useTransaction();

  const isCopyingTransaction =
    Boolean(transaction?.isCopiedTransaction) &&
    !transaction?.activityId &&
    !transaction?.workTimeId;

  const dismissCopyTransactionBanner = () => {
    updateTransaction({ ...transaction, isCopyBannerDismissed: true } as ITransaction);
  };

  return {
    showCopyTransactionBanner: isCopyingTransaction && !transaction?.isCopyBannerDismissed,
    copyTransactionBannerMessage: t('transaction:copyCreatesNewTransaction'),
    dismissCopyTransactionBanner,
  };
};
